// src/pages/Advertisement/EmailSentAds.tsx

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HighLogo from '../../HighLogo';
import logo from '../../../assets/logo.png';
import StartFooter from '../StartFooterAd';

const EmailSentAds = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const email =
    (location.state as { email?: string } | null)?.email || '';

  return (
    <div style={pageStyle}>
      <div style={floatingLogoStyle}>
        <button
          type="button"
          onClick={() => navigate('/ads-home')}
          aria-label="Go to ELNYDO Ads homepage"
          style={floatingLogoButtonStyle}
        >
          <HighLogo
            src={logo}
            style={{
              width: 190,
              display: 'block',
            }}
            padding={0}
          />
        </button>
      </div>

      <main style={mainStyle}>
        <section style={emailSentPanel}>
          <h1 style={titleStyle}>
            <span style={{ color: '#f8fafc' }}>
              📧 {t('emailSentTitle')}
            </span>{' '}

            <span
              style={{
                background:
                  'linear-gradient(135deg, #f97316 0%, #facc15 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              ELNYDO Ads
            </span>
          </h1>

          <p style={subtitleStyle}>
            {t('emailSentSubtitle')}{' '}
            {email && <strong style={emailStyle}>{email}</strong>}
          </p>

          <p style={noteStyle}>
            {t('emailSentNote')}
          </p>

          <button
            type="button"
            onClick={() => navigate('/ad-login')}
            style={returnButton}
          >
            {t('emailSentReturnButton')}
          </button>
        </section>
      </main>

      <StartFooter />
    </div>
  );
};

export default EmailSentAds;

const pageStyle: React.CSSProperties = {
  minHeight: '100vh',
  width: '100%',
  background:
    'radial-gradient(circle at top, #020617 0, #000 40%, #020617 100%)',
  color: '#f9fafb',
  fontFamily:
    'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
  display: 'flex',
  flexDirection: 'column',
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '42px 32px',
  boxSizing: 'border-box',
};

const emailSentPanel: React.CSSProperties = {
  width: '100%',
  maxWidth: 440,
  borderRadius: 28,
  border: '1px solid rgba(148,163,184,0.24)',
  background:
    'linear-gradient(145deg, rgba(15,23,42,0.94), rgba(2,6,23,0.98))',
  boxShadow: '0 30px 80px rgba(0,0,0,0.75)',
  padding: '38px 42px 40px',
  boxSizing: 'border-box',
  textAlign: 'center',
};

const titleStyle: React.CSSProperties = {
  margin: '0 0 18px',
  fontSize: 28,
  lineHeight: 1.15,
  letterSpacing: '-0.8px',
  fontWeight: 800,
};

const subtitleStyle: React.CSSProperties = {
  margin: '0 auto',
  fontSize: 14,
  lineHeight: 1.6,
  color: '#e5e7eb',
};

const emailStyle: React.CSSProperties = {
  color: '#facc15',
  overflowWrap: 'anywhere',
};

const noteStyle: React.CSSProperties = {
  margin: '14px auto 0',
  fontSize: 13,
  lineHeight: 1.5,
  color: '#94a3b8',
};

const returnButton: React.CSSProperties = {
  width: '100%',
  marginTop: 28,
  padding: '13px 18px',
  borderRadius: 999,
  border: 'none',
  background:
    'linear-gradient(135deg, rgba(212,175,55,1), rgba(250,250,210,0.95))',
  color: '#111827',
  cursor: 'pointer',
  fontSize: 15,
  fontWeight: 800,
  boxShadow: '0 12px 30px rgba(212,175,55,0.18)',
};

const floatingLogoStyle: React.CSSProperties = {
  width: '100%',
  padding: '28px 20px 0',
  boxSizing: 'border-box',
};

const floatingLogoButtonStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
};